import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import '../css/AgentDashboard.css'; // Import the CSS file
import { getSubscriptionsByAgentId, getReportByAgentId } from '../services/api'; // Import the functions from your API module

// Register Chart.js elements and plugins
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const AgentDashboard = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [reports, setReports] = useState([]); 

  const [chartData, setChartData] = useState({
    labels: ['Remaining Usage', 'Current Usage'],
    datasets: [
      {
        data: [],
        backgroundColor: ['#66b3ff', '#ff9999'],
      },
    ],
  });

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const agentId = localStorage.getItem("agentId");
        console.log("AgentId from localStorage:", agentId); // Debugging
        const response = await getSubscriptionsByAgentId(agentId); // Use the function from your API module
        console.log("==response.data==", response.data); // Debugging

        // Check if response.data is an object
        if (response.data && typeof response.data === 'object') {
          setSubscriptions([response.data]); // Convert object to array

          // Prepare data for the pie chart
          const { currentUsage, remainingUsage } = response.data;

          setChartData({
            labels: ['Remaining Usage', 'Current Usage'],
            datasets: [
              {
                data: [remainingUsage, currentUsage],
                backgroundColor: ['#66b3ff', '#ff9999'],
              },
            ],
          });
        } else {
          console.error('Expected an object but got:', response.data);
        }
      } catch (error) {
        console.error('Error fetching subscriptions:', error);
      }
    };

    fetchSubscriptions();
  }, []);

  const handleButtonClick = async () => {
    const agentId = localStorage.getItem("agentId"); // Get agent ID from local storage
    console.log("jagan Agent ID:", agentId);
    try {
      const response = await getReportByAgentId(agentId);
      console.log(response.data); // Handle the response data as needed
      setReports(response.data); // Update reports state with fetched data

    } catch (error) {
      console.error('Error fetching reports:', error);
    }
  };

  return (
    <div className="dashboard-container">
      <h2>Subscriptions Details</h2>
      <div className="chart-container">
        {chartData.labels.length > 0 && (
          <Pie
            data={chartData}
            options={{
              plugins: {
                datalabels: {
                  formatter: (value, context) => {
                    return context.chart.data.labels[context.dataIndex] + ': ' + value;
                  },
                  color: '#fff',
                  font: {
                    weight: 'bold',
                  },
                },
              },
            }}
          />
        )}
      </div>
      <table className="agents-table">
        <thead>
          <tr>
            <th>Total Limit</th>
            <th>Threshold Limit</th>
            <th>Current Usage</th>
            <th>Remaining Usage</th>
          </tr>
        </thead>
        <tbody>
          {subscriptions.map(subscription => (
            <tr key={subscription.id}>
              <td>{subscription.totalLimit}</td>
              <td>{subscription.thresholdLimit}</td>
              <td>{subscription.currentUsage}</td>
              <td>{subscription.remainingUsage}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={handleButtonClick}>List of Generated Reports</button>

{reports.length > 0 && ( // Conditionally render the table
    <table className="agents-table">
        <thead>
            <tr>
               <th>Report Name</th>
               <th>Created Date</th>
               
            </tr>
        </thead>
        <tbody>
            {reports.map((report) => (
                <tr key={report.id}>
                   
                    <td>{report.reportName}</td>
                     <td>{report.createdAt ? new Date(report.createdAt).toLocaleString() : ''}</td> {/* Format date */}
                  
                </tr>
            ))}
        </tbody>
    </table>
)}


</div>
);
  
};

export default AgentDashboard;